import {defineStore} from 'pinia'
import VARS from "../config_chooser_choice_vars";
import axios from "axios";
import * as CONFIG from 'cw-conf'

export const useChooserStore = defineStore('ChooserStore', {
    persist: true,
    state: () => ({
        designsAreLoading: false,
        designs: [],
        designsCountTotal: 0,
        designIds: [],
        designsRowOffset: 0,
        designsRowCount: 12,
        selectedSortOrder: {
            id: 1,
            text: 'Default',
            sort: 'random'
        },
        selectedStaffPicks: false,
        selectedProductLine: 0,
        selectedOrientations: [VARS.ORIENTATION_ORIGINAL.id],
        priceRangeMin: 1000,
        priceRangeMax: 30000,
        priceRangeStep: 1000,
        selectedPriceRange: [1000, 30000],
        selectedDimensionWidth: [6, 50],
        selectedDimensionDepth: [6, 50],
        selectedSizes: ['sm', 'md', 'lg', 'xl'],
        selectedNumSwings: [0, 1, 2, 3, 4],
        selectedStructures: [],
        selectedConnectors: [],
        selectedSlides: [],
        selectedClimbingItems: [],
        selectedSwings: [],
        selectedFencesColorways: [VARS.FENCES_COLOR.id, VARS.FENCES_PLAIN.id],
        selectedDownstairsItems: [],
        requestInitiatedFromPlayhouseButton: false,
        selectedSearchMode: "simple",
        selectedSizesModeIsCheckboxes: true,
        resultsUrl: null
    }),

    getters: {
        isLineRustic: (state) => state.selectedProductLine === 18,
        isLineClassic: (state) => state.selectedProductLine === 19,
        isLineArchitectural: (state) => state.selectedProductLine === 20,
        isLineAny: (state) => state.selectedProductLine === 18 || state.selectedProductLine === 19 || state.selectedProductLine === 20
    },

    actions: {
        async retrieveItemsFromServer() {
            this.designsAreLoading = true;

            let r = await axios
                .get(CONFIG.SERVER_AJAX_URL + '/chooser/get-filtered-data', {
                    params: {
                        'sort': this.selectedSortOrder.sort,
                        'row_offset': this.designsRowOffset,
                        'row_count': this.designsRowCount,
                        'staff_picks': this.selectedStaffPicks,
                        'product_line': this.selectedProductLine,
                        'orientations': this.selectedOrientations,
                        'price_min': this.selectedPriceRange[0],
                        'price_max': this.selectedPriceRange[1],
                        'width_min': this.selectedDimensionWidth[0],
                        'width_max': this.selectedDimensionWidth[1],
                        'depth_min': this.selectedDimensionDepth[0],
                        'depth_max': this.selectedDimensionDepth[1],
                        'structures': this.selectedStructures,
                        'connectors': this.selectedConnectors,
                        'slides': this.selectedSlides,
                        'climbing_items': this.selectedClimbingItems,
                        'swings': this.selectedSwings,
                        'sizes': this.selectedSizes,
                        'numSwings': this.selectedNumSwings,
                        'fences_colorways': this.selectedFencesColorways,
                        'downstairs_items': this.selectedDownstairsItems,
                        'searchMode': this.selectedSearchMode,
                        'sizesModeIsCheckboxes': this.selectedSizesModeIsCheckboxes,
                        'fences': 1, // can delete eventually after 422 errors settle down, since fences is no longer used
                        'roofs': 1, // can delete eventually after 422 errors settle down, since roofs is no longer used
                    }
                })

            let requestedUrl = axios.getUri({url: r.config.url, params: r.config.params})

            let url = new URL(requestedUrl)

            let obj = new URLSearchParams(url.search)

            this.resultsUrl = CONFIG.SERVER_AJAX_URL + '/chooser/load?' + obj.toString()

            let len = r.data.designIds.length

            if (this.designsRowOffset > 0 && len > 0) {
                for (const [key, value] of Object.entries(r.data.designs)) {
                    let design = {}

                    design[key] = value;

                    this.addDesign(design)
                }

                for (let i = 0; i < len; i++) {
                    this.addDesignId(r.data.designIds[i])
                }
            } else {
                this.designs = r.data.designs;
                this.designIds = r.data.designIds;
            }

            this.setDesignsRowOffset();
            this.designsCountTotal = r.data.designsCountTotal;
            this.designsAreLoading = false;
        },

        addDesign(design) {
            this.designs = Object.assign(this.designs, design)
        },

        addDesignId(designId) {
            this.designIds.push(designId)
        },

        setDesignsRowOffset() {
            this.designsRowOffset += this.designsRowCount
        },

        resetDesignsRowOffset() {
            this.designsRowOffset = 0
        },

        async resetSelections() {
            let selectedProductLineBeforeReset = this.selectedProductLine

            await this.$reset()

            this.selectedProductLine = selectedProductLineBeforeReset

            this.resetDesignsRowOffset()

            await this.retrieveItemsFromServer()

            // this.selectedSearchMode = "simple" // NO CLUE WHY I HAVE TO SET THIS HERE, BUT I DO!
        },

        toggleSelectedSizesModeIsCheckboxes() {
            this.selectedSizesModeIsCheckboxes = !this.selectedSizesModeIsCheckboxes
        }
    }
})
